import classes from './tabs.module.css'

const Tabs = {
  classNames: {
    root: classes.root,
  },
}

export default Tabs
